'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.PlayerState = void 0;
(function(PlayerState2) {
  PlayerState2[PlayerState2["UNSTARTED"] = -1] = "UNSTARTED";
  PlayerState2[PlayerState2["ENDED"] = 0] = "ENDED";
  PlayerState2[PlayerState2["PLAYING"] = 1] = "PLAYING";
  PlayerState2[PlayerState2["PAUSED"] = 2] = "PAUSED";
  PlayerState2[PlayerState2["BUFFERING"] = 3] = "BUFFERING";
  PlayerState2[PlayerState2["CUED"] = 5] = "CUED";
})(exports.PlayerState || (exports.PlayerState = {}));
exports.PlayerError = void 0;
(function(PlayerError2) {
  PlayerError2[PlayerError2["InvalidParam"] = 2] = "InvalidParam";
  PlayerError2[PlayerError2["Html5Error"] = 5] = "Html5Error";
  PlayerError2[PlayerError2["VideoNotFound"] = 100] = "VideoNotFound";
  PlayerError2[PlayerError2["EmbeddingNotAllowed"] = 101] = "EmbeddingNotAllowed";
  PlayerError2[PlayerError2["EmbeddingNotAllowed2"] = 150] = "EmbeddingNotAllowed2";
})(exports.PlayerError || (exports.PlayerError = {}));
//# sourceMappingURL=types.cjs.js.map
